module.exports = __webpack_public_path__ + "static/media/aid-first-medical-svgrepo-com.4f33fd46.svg";